<div class="report-sms">
    <div class="report-sms__header">
        <div class="header__count">
            <div class="count__text">
                <h2 class="count__title">סמסים {{ smsCount }}</h2>
                <span class="count__details">זמינים כעת</span>
            </div>
            <img class="count__icon" src="/assets/img/Automation/icon-sms.svg" />
        </div>

        <h1 class="header__days">דוח {{ daysRange }} ימים אחרונים</h1>
    </div>

    <div class="report-sms__card card">
        <div class="report-sms__settings">
            <div class="settings__filter">
                <div class="input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select filter__input-wrapper">
                    <span class="input-label">סטטוס</span>
                    <select class="input" [(ngModel)]="selectedMethod">
                        <option *ngFor="let option of showData">{{ option.name }}</option>
                    </select>
                </div>

                <div class="input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_datepicker filter__input-wrapper">
                    <span class="input-label">עד תאריך</span>
                    <input
                        class="input"
                        bsDatepicker
                        [(appDateMask)]="dateTo"
                        [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', adaptivePosition: true, isAnimated: true }"
                        [maxDate]="maxDate"
                        [(ngModel)]="dateTo"
                        type="text"
                        placeholder="בחר"
                        autocomplete="off"
                    />
                </div>

                <div class="input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_datepicker filter__input-wrapper">
                    <span class="input-label">מתאריך</span>
                    <input
                        class="input"
                        bsDatepicker
                        [(appDateMask)]="dateFrom"
                        [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', adaptivePosition: true, isAnimated: true }"
                        [maxDate]="maxDate"
                        [(ngModel)]="dateFrom"
                        type="text"
                        placeholder="בחר"
                        autocomplete="off"
                    />
                </div>
            </div>

            <div class="settings__buttons">
                <button class="button button_size_small button_icon-only button_theme_main-line" (click)="refreshFilters()">
                    <i class="fa-regular fa-xmark"></i>
                </button>
                <button class="button button_size_small button_with-icon button_theme_main button__search" (click)="getReports()">
                    חפש
                    <i class="fa-regular fa-magnifying-glass"></i>
                </button>
            </div>
        </div>

        <p-table
            class="table report-sms__table"
            [value]="smsmain_reps"
            sortField="smsdate"
            [sortOrder]="-1"
            [rows]="10"
            [paginator]="true"
            [alwaysShowPaginator]="false"
            [first]="startFromReport"
        >
            <ng-template pTemplate="header">
                <tr class="table__row">
                    <th class="table-header__column">סטטוס</th>
                    <th class="table-header__column">כמות</th>
                    <th class="table-header__column">סוג</th>
                    <th class="table-header__column">תאריך שליחה</th>
                    <th class="table-header__column column__button"></th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-report>
                <tr
                    *ngIf="!isReportsLoading"
                    class="table__row"
                    [ngClass]="{
                        table__row_failed: report.quantity <= report.quantityfailed
                    }"
                >
                    <td
                        class="table__column column__status"
                        [ngClass]="{
                            column__status_successful: report.status == 'נשלח',
                            column__status_failed: report.status == 'נכשל'
                        }"
                    >
                        <i *ngIf="report.status == 'נשלח'" class="fa-solid fa-check"></i>
                        <i *ngIf="report.status == 'נכשל'" class="fa-solid fa-xmark"></i>
                        {{ report.status }}<span *ngIf="report.status == 'נכשל'">: {{ report.quantityfailed }}</span>
                    </td>
                    <td class="table__column">{{ report.quantity }}</td>
                    <td class="table__column">{{ report.smstype }}</td>
                    <td class="table__column column__date">{{ report.smsdate | date : "dd/MM/yyyy HH:mm" }}</td>
                    <td class="table__column column__button">
                        <button class="button button_icon-only button_theme_main-line button__info" (click)="openReport(report)">
                            <i class="fa-regular fa-circle-info"></i>
                        </button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="summary">
                <span *ngIf="isReportsLoading" class="report-sms__loader"></span>

                <span class="report-sms__total-sms">נשלחו בתקופה SMS {{ loadedSmsCount }} </span>
            </ng-template>
        </p-table>
    </div>

    <!-- Small screens -->
    <div class="report-sms__loader-wrapper">
        <span *ngIf="isReportsLoading" class="report-sms__loader report-sms__loader_small"></span>
    </div>

    <div *ngIf="!isReportsLoading">
        <div *ngFor="let report of smsmain_reps" class="report-sms__card card report-card" (click)="openReport(report)">
            <div class="report-card__row">
                <span class="report-card__value value__date">
                    <button class="button button_icon-only button_theme_main-line button__info">
                        <i class="fa-regular fa-circle-info"></i>
                    </button>
                    <span>{{ report.smsdate | date : "dd/MM/yyyy HH:mm" }}</span>
                </span>
                <span class="report-card__label">תאריך שליחה</span>
            </div>

            <div class="report-card__row">
                <span class="report-card__value">{{ report.smstype }}</span>
                <span class="report-card__label">סוג</span>
            </div>

            <div class="report-card__row">
                <span class="report-card__value">{{ report.quantity }}</span>
                <span class="report-card__label">כמות</span>
            </div>

            <div class="report-card__row">
                <span
                    class="report-card__value value__status"
                    [ngClass]="{
                        value__status_successful: report.status == 'נשלח',
                        value__status_failed: report.status == 'נכשל'
                    }"
                >
                    <i *ngIf="report.status == 'נשלח'" class="fa-solid fa-check"></i>
                    <i *ngIf="report.status == 'נכשל'" class="fa-solid fa-xmark"></i>
                    {{ report.status }}<span *ngIf="report.status == 'נכשל'">: {{ report.quantityfailed }}</span>
                </span>
                <span class="report-card__label">סטטוס</span>
            </div>
        </div>
    </div>
</div>
